import React, { useEffect, useState } from 'react'
import Main from '../../cpn/Main'
import { Space, Table } from 'antd';
import { useHangyeTypeListQuery } from '../../store/dianshangtaizhangApi';
import TradeEdit from './TradeEdit';
function TradeQuery() {
    const [list, setList] = useState();    
    const {data, isSuccess} = useHangyeTypeListQuery()
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {hyt_id:key,hyt_name,} = item;                 
                    return item = {key,hyt_name,}
                }) 
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.hyt_ctime;
                    let bTimeString = b.hyt_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'hyt_name',
            title: '行业',            
            dataIndex: 'hyt_name',
        },
        
        {
            key: 'num',
            title: '编号',            
            dataIndex: 'key',
        },       
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <TradeEdit hyt_id={record.key} hyt_name={record.hyt_name}/>
                    </Space>
                </>
            }
        },
    ]   
    return (
        <Main selectedKeys={['/TradeList']}>
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'50',
                    showTotal:(total) => `共${total}条`,
                }} 
                style={{marginTop:'10px'}}
            />
        </Main>
    )
}

export default TradeQuery